import { FETCH_TECHNICAL_ABSENCES_RELATORY_INIT } from './TechnicalAbsencesRelatoryActions'

const INITIAL_STATE = {
  items: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  filters: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_TECHNICAL_ABSENCES_RELATORY_INIT.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        totalSize: action.payload.data.meta.total,
        page: action.payload.data.meta.current_page,
        sizePerPage: action.payload.data.meta.per_page,
        filters: action.payload.filters,
      }
    case "CLEAR_ACTION_TECHNICAL_ABSENCES":
      return {
        ...state,
        filters: []
      }
    default:
      return state
  }
}

export const getTechnicalAbsencesRelatoryListData = state => {
  return {
    items: state.technical_absences_relatory.items,
    page: state.technical_absences_relatory.page,
    sizePerPage: state.technical_absences_relatory.sizePerPage,
    totalSize: state.technical_absences_relatory.totalSize,
    filters: state.technical_absences_relatory.filters,
  }
}
